import React from "react";
import { motion } from "framer-motion";
import * as common from "../common";
import banner1 from "../../assets/banner/banner1.png";
import banner2 from "../../assets/banner/banner2.png";
import banner3 from "../../assets/banner/banner3.png";
import banner4 from "../../assets/banner/Border.png";

const ShopCardsSection = (props) => {
  const banner = props?.banners;

  return (
    <section>
      {/* cards Section */}

      {props?.banners?.length > 0 &&
        banner.map((item) => (
          <common.ShopCard
            Title={item?.title}
            bgColor="bg-[#EDF1FF]"
            // bgColor='bg-red'
            imgSource={item?.banner_img ? item?.banner_img : banner1}
            btnTitle={item?.cat_name}
            category={item?.cat_name}
            cardText={item?.banner_desc}
          />
        ))}

      {/* <common.ShopCard
                Title="Shop Like a Man. Dress Like a Legend"
                bgColor="bg-[#EDF1FF]"
                imgSource={
                    banner[0]?.banner_img
                        ? `${process.env.REACT_APP_API_BASE_URL}/${banner[0].banner_img}`
                        : banner1
                }
                btnTitle="Mens Collection"
                category="mens"
                cardText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the"
            />

            <common.ShopCard
                Title="Style as Beautiful Woman as You Are."
                bgColor="bg-[#FFECF6]"
                imgSource={
                    banner[1]?.banner_img
                        ? `${process.env.REACT_APP_API_BASE_URL}/${banner[1].banner_img}`
                        : banner2
                }
                btnTitle="Womens Collection"
                category="womens"
                cardText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the"
            />

            <common.ShopCard
                Title="Big Style for Little Stars."
                bgColor="bg-[#FCFFD5]"
                imgSource={
                    banner[2]?.banner_img
                        ? `${process.env.REACT_APP_API_BASE_URL}/${banner[2].banner_img}`
                        : banner3
                }
                btnTitle="Kids Fashion"
                category="kids"
                cardText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the"
            /> */}
    </section>
  );
};

export default ShopCardsSection;
